import React from 'react'
import { Helmet } from 'react-helmet'
import ThumbupIcon from '../../asset/thumbup.svg'
import LoadingPage from '../../components/LoadingPageCard'
import { mockEmailModalData } from '../../data/modalContentData'
import NotificationModal from '../../components/NotificationModal'
import { LoadingPageContainer } from '../../components/PageWrapper/styles'

const AuthorsingLoading = () => {
  const LoadingPageData = {
    centerIcon: ThumbupIcon,
    title: 'You have authorised data sharing with CompareBanks',
    subtitle: 'We will now take you back to CompareBanks.',
    redirectPath: '/generating',
  }

  return (
    <LoadingPageContainer>
      <Helmet>
        <title>Loading</title>
        <link rel="icon" href="./asset/bankIcon.svg" />
      </Helmet>
      <NotificationModal {...mockEmailModalData} />
      <LoadingPage {...LoadingPageData} />
    </LoadingPageContainer>
  )
}

export default AuthorsingLoading
